// import {apiAction} from './helper';

export const SET_PP_PROPS = 'SET_PP_PROPS';
export const CHANGE_SELECT_ALL_PPS = 'CHANGE_SELECT_ALL_PPS';
export const SET_MULTI_PP_PROPS = 'SET_MULTI_PP_PROPS';
export const SET_PPS = 'SET_PPS';
